import _ from "underscore"
import BasePDFDefinitionCreator from "../BasePDFDefinitionCreator";
import DataTableCreateDefinitionHelper from "../leavesReport/DataTableCreateDefinitionHelper";
import PDFImageCache from "../PDFImageCache"
import {atImgPath} from "../../atBrowserUtils"
import PDFDefinitionBuilder from "./PDFDefinitionBuilder";
import {REPORT_LOGO_PATH, PaperOrientation} from "../constants";
import * as PDFDefinitionColumnBuilder from "./PDFDefinitionColumnBuilder";

export default class PDFDefinitionCreator extends BasePDFDefinitionCreator{
    
    createDocDefinition(pdfConfig, parameterFormatter, store)
    {
        this.parameterFormatter = parameterFormatter;
        this.pdfPrintParams = pdfConfig.pdfPrintParameters;
        this.pdfData = pdfConfig.pdfData;
        this.pdfConfig = pdfConfig;
        this.reportParams = pdfConfig.reportParams;
        this.dateFormat = this.pdfConfig.dateFormat;

        var rowSpanNumber = this.reportParams.includeNotEstimated ? 3 : 2;

        var columns = [];
        columns.push(new PDFDefinitionColumnBuilder.Levels().init(this.reportParams, store, rowSpanNumber));

        if (this.reportParams.includeNotEstimated)
        {
            columns.push(new PDFDefinitionColumnBuilder.TotalSpentTime().init(this.reportParams, rowSpanNumber));
            columns.push(new PDFDefinitionColumnBuilder.SpentTimeForNotEstimated().init(this.reportParams, rowSpanNumber));
            columns.push(new PDFDefinitionColumnBuilder.EstimatedTasksBlock().init(this.reportParams, store, rowSpanNumber));
        }
        else
        {
            columns.push(new PDFDefinitionColumnBuilder.SpentTimeForEstimated().init(this.reportParams, rowSpanNumber));
            columns.push(new PDFDefinitionColumnBuilder.EstimatedTime().init(this.reportParams, rowSpanNumber));
            columns.push(new PDFDefinitionColumnBuilder.VarianceTime().init(this.reportParams, rowSpanNumber));
        }

        var ddb = new PDFDefinitionBuilder();
        ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize, columns, rowSpanNumber);

        // start create doc definition
        return PDFImageCache
            .preloadImages(this._imagesMap(pdfConfig)) // preload needed images
            .then(
                _.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
            )
            .then(function()
            {
                // return object for generate pdf
                return {
                    "docDefinition": ddb.getDocDefinitionObject(),
                    "tableLayouts": ddb.getTableLayouts()
                }
            });
    }

    _imagesMap()
    {
        return {
            "logo": {
                "url": REPORT_LOGO_PATH
            },
            "filterIcon": {
                "url": atImgPath('filter-for-pdf.png'),
                "saveAlpha": true
            }
        };
    }

    _processCreateDocDefinition(ddb)
    {
        ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

        var headerData = this._createHeaderData();
        if (this.pdfPrintParams.paperOrientation == PaperOrientation.PORTRAIT)
        {
            ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
        }
        else
        {
            ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData)
        }


        this._addTableData(ddb);
    }

    _createHeaderData()
    {
        var selectedParameters = this.pdfConfig.reportParams;
        var assignedInfo = this.pdfConfig.assignedInfo;

        return {
            informationTexts: {
                title: this.parameterFormatter.formatChartPDFReportTitle(selectedParameters),
                dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
            },
            filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters, assignedInfo),
            logo: PDFImageCache.getImage('logo')
        }
    }

    _addTableData(ddb)
    {
        new DataTableCreateDefinitionHelper(ddb, this.pdfData.tableData, {
            dateFormat: this.dateFormat
        }).createTable();
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/evaReport/PDFDefinitionCreator.js